#import "../../fragments/booking/DetailedBookingDetails.gql"
mutation booking($input: BookingMutationInput!) {
  booking(input: $input) {
    success
    booking {
      ...DetailedBookingDetails
    }
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
